/*
 * The one answer to "how does this kind of Activity row read": core's own kinds first
 * (`coreRows.ts`), then the module that registered the kind. The feed and the desktop banner both ask
 * here, so a kind core reads itself — a document's mention, a reply to a thread someone started —
 * reads and banners the same way in both, and neither surface can forget core's kinds.
 */

import type { ActivityRowView, ModuleRegistry } from "../modules/registry.ts"
import { coreActivityRow } from "./coreRows.ts"

type Rows = Pick<ModuleRegistry, "activityRow">

/** How one kind's rows read in the feed; undefined for a kind nobody gave a view. */
export function activityRowView(kind: string, registry: Rows): ActivityRowView | undefined {
	return coreActivityRow(kind) ?? registry.activityRow(kind)
}

/**
 * The view of one row that is to banner on the desktop, or undefined when its kind never banners or
 * this row of it should not: Claude's mention, a reply on a row that is not the thread starter's.
 */
export function activityBannerView(
	kind: string,
	data: unknown,
	registry: Rows,
): ActivityRowView | undefined {
	const core = coreActivityRow(kind)
	if (core !== undefined)
		return core.desktop !== undefined && (core.banners?.(data) ?? true) ? core : undefined
	const view = registry.activityRow(kind)
	return view?.desktop === undefined ? undefined : view
}
